var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class AlbumsApi {
    constructor(http) {
        this.http = http;
    }
    getAlbum(albumId, options) {
        return this.http.get(`/albums/${albumId}`, options && { params: options });
    }
    getAlbums(albumIds, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.get('/albums', {
                params: Object.assign(Object.assign({}, options), { ids: albumIds }),
            });
            return response.albums;
        });
    }
    getAlbumTracks(albumId, options) {
        return this.http.get(`/albums/${albumId}/tracks`, options && { params: options });
    }
}
//# sourceMappingURL=AlbumsApi.js.map